import { createAction, createSlice } from "@reduxjs/toolkit";
import { PaymentProvider } from "../models/PaymentProvider";
import listFactory from "./listFactory";

const { slicePart, selectors } = listFactory<PaymentProvider>(
  "paymentsProviders"
);

const initialState = {
  ...slicePart.initialState,
};

export const slice = createSlice({
  ...slicePart,
  initialState,
  reducers: {
    setList: slicePart.reducers.setList,
  },
});

export const { setList: setPaymentsProviders } = slice.actions;

export const fetchPaymentsProviders = createAction("fetchPaymentsProviders");

export const { selectList: selectPaymentsProviders } = selectors;

export const paymentsProvidersOperationPaths = () => {
  return {
    listing: ["paymentsProviders", "list"],
  };
};

export default slice.reducer;
